import { Component, OnInit } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import { ChequeEnquiryService } from "src/app/services/autopac/cheque-enquiry.service";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-cheque-enquiry",
  templateUrl: "./cheque-enquiry.component.html",
  styleUrls: ["./cheque-enquiry.component.css"],
})
export class ChequeEnquiryComponent {
  form: FormField[] = [
    {
      type: "search",
      id: "CHEQUENO",
      label: "Cheque number",
      searchEvent: true,
      searchType: "searchCheque",
    },
    {
      type: "text",
      id: "CUSTOMERNAME",
      label: "Buyer name",
      lock: true,
    },
    {
      type: "text",
      id: "CONTRACTNO",
      label: "Contract number",
      lock: true,
    },
    {
      type: "text",
      id: "PAYTO",
      label: "Pay to",
      lock: true,
    },
    {
      type: "text",
      id: "CHEQUEDATE",
      label: "Cheque date",
      lock: true,
    },
    {
      type: "text",
      id: "BANK",
      label: "Bank",
      lock: true,
    },
    {
      type: "text",
      id: "PAYAMOUNT",
      label: "Amount",
      lock: true,
    },
    {
      type: "text",
      id: "PURPOSE",
      label: "Purpose",
      lock: true,
    },
  ];

  constructor(
    private chequeEnquiryService: ChequeEnquiryService,
    private notifier: NotifierService,
  ) {}

  search(): void {
    const chequeNo = this.getField("CHEQUENO").value;

    if (!chequeNo) {
      this.notifier.notify("error", "Please enter a cheque number");
      return;
    }

    this.chequeEnquiryService.getChequeDetails(chequeNo).subscribe({
      next: (response) => {
        if (response.code !== 0) {
          this.notifier.notify("error", response.message);
          return;
        }

        for (const [key, value] of Object.entries(response.body)) {
          this.getField(key).value = value;
        }
      },
      error: (error) => {
        console.error("Error fetching cheque details:", error);
      },
    });
  }

  private getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }
}
